import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ServiceImage } from "./serviceComponent/serviceImage/serviceImage";
import { ServiceData } from "./serviceComponent/serviceData/serviceData";
import './serviceDetailsPage.css';


export const ServiceDetailsPage = ({ onPageChange, serviceList, service_id }) => {

  const handleServiceClick = () => {
    onPageChange("service");
  };

 


  return (
    <Container fluid>  
   <button className="go-back" onClick={handleServiceClick}>Go Back</button>
        <Row>
          <Col>
              <ServiceImage serviceList={serviceList} service_id={service_id} />
          </Col>
        </Row>
        <Row>
          <Col>
              <ServiceData service_id={service_id} />
          </Col>
        </Row>
    </Container>
  );
};
